export default __webpack_public_path__ + "static/media/down-caret.addc4ca2.svg";